import { Arr_SEFPages } from "../../../../arrays/SEF/Arr_SEFPages";
import getNestedPropByID from "../../../../functions/getNestedPropByID";

function ConsultantBookingTable({
  Arr_Bookings,
  Arr_BasicSEFPages,
  Arr_AdvancedSEFPages,
  countUnpaidInvoices,
  checkSEFProgress,
  handleExpand,
  handleOpenSEFPage,
  obj_EC,
  Arr_ECs,
  handleSendSEFPage,
}) {
  return (
    <div
      style={{
        overflowX: "scroll",
        overflowY: "auto",
        maxHeight: "calc(100vh - 300px)",
      }}
    >
      <table id="BookingTable">
        <thead>
          <tr>
            {obj_EC.MetaData?.Admin === "Yes" ? <th>Colleague Name</th> : <></>}
            <th>First Name</th>
            <th>Last Name</th>
            <th>Programme Title</th>
            <th>Programme Date</th>
            <th>Programme Varient</th>
            <th>Registered</th>
            <th>Invoice Status</th>
          </tr>
        </thead>
        <tbody>
          {Arr_Bookings.map((obj_booking, index) => (
            <>
              <tr key={index}>
                {obj_EC.MetaData?.Admin === "Yes" ? (
                  <td>
                    {getNestedPropByID(
                      Arr_ECs,
                      obj_booking.IPInfo?.EC_ID,
                      "First_Name",
                      "BasicInfo"
                    )}
                  </td>
                ) : (
                  <></>
                )}
                <td>{obj_booking.BasicInfo?.First_Name || ""}</td>
                <td>{obj_booking.BasicInfo?.Last_Name || ""}</td>
                <td>{obj_booking.BasicInfo?.ProgrammeTitle || ""}</td>
                <td>{obj_booking.BasicInfo?.ProgrammeDate || ""}</td>
                <td>{obj_booking.BasicInfo?.ProgrammeVarient || ""}</td>

                {obj_booking.MetaData?.Archived === "Yes" ? (
                  <td style={{ backgroundColor: "#f1948a" }}>Removed</td>
                ) : obj_booking.MetaData?.Reserved === "Yes" ? (
                  <td style={{ backgroundColor: "#85c1e9" }}>Reserved</td>
                ) : (
                  <td style={{ backgroundColor: "#DAF7A6" }}>Confirmed</td>
                )}
                {obj_booking.MetaData?.Archived === "Yes" ? (
                  <td style={{ backgroundColor: "grey" }}></td>
                ) : (
                  <td>{countUnpaidInvoices(obj_booking)}</td>
                )}
              </tr>
              {obj_booking.BasicInfo?.ProgrammeTitle &&
              obj_booking.BasicInfo?.ProgrammeTitle.toLowerCase().includes(
                "weekend"
              ) ? (
                <></>
              ) : (
                <>
                  <tr key={index + "p2"}>
                    <td style={{}}></td>
                    <td>Student Enrollment Form:</td>
                    <td
                      className={`ProgressBox ${
                        checkSEFProgress(obj_booking, Arr_BasicSEFPages) ===
                        "Complete"
                          ? "Complete"
                          : checkSEFProgress(obj_booking, Arr_BasicSEFPages) ===
                            "In Progress"
                          ? "In_Progress"
                          : checkSEFProgress(obj_booking, Arr_BasicSEFPages) ===
                            "Awaiting Review"
                          ? "Awaiting_Review"
                          : "Incomplete"
                      }`}
                    >
                      Basic: {checkSEFProgress(obj_booking, Arr_BasicSEFPages)}
                    </td>
                    <td
                      className={`ProgressBox ${
                        checkSEFProgress(obj_booking, Arr_AdvancedSEFPages) ===
                        "Complete"
                          ? "Complete"
                          : checkSEFProgress(
                              obj_booking,
                              Arr_AdvancedSEFPages
                            ) === "In Progress"
                          ? "In_Progress"
                          : checkSEFProgress(
                              obj_booking,
                              Arr_AdvancedSEFPages
                            ) === "Awaiting Review"
                          ? "Awaiting_Review"
                          : "Incomplete"
                      }`}
                    >
                      Adv: {checkSEFProgress(obj_booking, Arr_AdvancedSEFPages)}
                    </td>
                    <td
                      className={`ProgressBox ${
                        obj_booking.SEFInfo?.SEF === "Complete"
                          ? "Complete"
                          : obj_booking.SEFInfo?.SEF === "In_Progress"
                          ? "In_Progress"
                          : obj_booking.SEFInfo?.SEF === "Awaiting_Review"
                          ? "Awaiting_Review"
                          : "Incomplete"
                      }`}
                    >
                      All:{" "}
                      {obj_booking.SEFInfo && obj_booking.SEFInfo?.SEF
                        ? obj_booking.SEFInfo?.SEF.replaceAll("_", " ")
                        : "Incomplete"}
                    </td>
                    <td>
                      <button
                        class="w3-button w3-teal w3-padding-large"
                        style={{
                          textAlign: "center",
                        }}
                        onClick={(e) => handleExpand(e, obj_booking)}
                      >
                        {obj_booking.Expand === "Yes" ? (
                          <>
                            Shrink
                            <i
                              class="fa fa-long-arrow-up"
                              style={{ marginLeft: "10px" }}
                            ></i>
                          </>
                        ) : (
                          <>
                            Expand
                            <i
                              class="fa fa-long-arrow-down"
                              style={{ marginLeft: "10px" }}
                            ></i>
                          </>
                        )}
                      </button>
                    </td>
                    {obj_booking.BasicInfo?.ProgrammeTitle.toLowerCase().includes(
                      "weekend"
                    ) ? (
                      <></>
                    ) : (
                      <td>
                        <button
                          class=" w3-padding-large"
                          style={{
                            textAlign: "center",
                          }}
                          onClick={(e) => handleSendSEFPage(e, obj_booking)}
                        >
                          Email Safeguarding Enrolment Form to Parents/Student
                        </button>
                      </td>
                    )}
                  </tr>
                  {obj_booking.Expand === "Yes" ? (
                    <>
                      {Arr_SEFPages.map((obj_SEFPage, index) => (
                        <tr>
                          <td style={{ backgroundColor: "" }}></td>
                          <td>{obj_SEFPage.label}</td>
                          <td
                            className={`ProgressBox ${
                              obj_booking.SEFProgress?.[obj_SEFPage.Prop] ===
                              "Complete"
                                ? "Complete"
                                : obj_booking.SEFProgress?.[
                                    obj_SEFPage.Prop
                                  ] === "In_Progress"
                                ? "In_Progress"
                                : obj_booking.SEFProgress?.[
                                    obj_SEFPage.Prop
                                  ] === "Awaiting_Review"
                                ? "Awaiting_Review"
                                : "Incomplete"
                            }`}
                          >
                            {obj_booking.SEFProgress &&
                            obj_booking.SEFProgress[obj_SEFPage.Prop]
                              ? obj_booking.SEFProgress[obj_SEFPage.Prop] ===
                                "Complete"
                                ? "Complete"
                                : obj_booking.SEFProgress[obj_SEFPage.Prop] ===
                                  "In_Progress"
                                ? "In Progress"
                                : obj_booking.SEFProgress[obj_SEFPage.Prop] ===
                                  "Incomplete"
                                ? "Incomplete"
                                : obj_booking.SEFProgress[obj_SEFPage.Prop] ===
                                  "Awaiting_Review"
                                ? "Awaiting Review"
                                : "Incomplete"
                              : "Incomplete"}
                          </td>
                          {obj_SEFPage.level === "Basic" ? (
                            <td style={{ backgroundColor: "" }}>
                              <button
                                onClick={(e) =>
                                  handleOpenSEFPage(e, obj_booking, obj_SEFPage)
                                }
                              >
                                Go To{" "}
                              </button>
                            </td>
                          ) : (
                            <td style={{ backgroundColor: "" }}>
                              Parents/ Legal Guardians Only
                            </td>
                          )}
                        </tr>
                      ))}
                      {/* Show the arrival/ departure status for accom only*/}
                      {obj_booking.BasicInfo?.ProgrammeVarient &&
                      obj_booking.BasicInfo?.ProgrammeVarient.toLowerCase().includes(
                        "accom"
                      ) ? (
                        <tr>
                          <td style={{ backgroundColor: "" }}></td>
                          <td style={{ backgroundColor: "" }}>
                            Arrival/ Departure Info
                          </td>
                          <td
                            className={`ProgressBox ${
                              obj_booking.SummerArrivalDeparture?.Progress ===
                              "Complete"
                                ? "Complete"
                                : obj_booking.SummerArrivalDeparture
                                    ?.Progress === "In_Progress"
                                ? "In_Progress"
                                : obj_booking.SummerArrivalDeparture
                                    ?.Progress === "Awaiting_Review"
                                ? "Awaiting_Review"
                                : "Incomplete"
                            }`}
                          >
                            {obj_booking.SummerArrivalDeparture &&
                            obj_booking.SummerArrivalDeparture?.Progress
                              ? obj_booking.SummerArrivalDeparture?.Progress ===
                                "Complete"
                                ? "Complete"
                                : obj_booking.SummerArrivalDeparture
                                    ?.Progress === "In_Progress"
                                ? "In Progress"
                                : obj_booking.SummerArrivalDeparture
                                    ?.Progress === "Incomplete"
                                ? "Incomplete"
                                : obj_booking.SummerArrivalDeparture
                                    ?.Progress === "Awaiting_Review"
                                ? "Awaiting Review"
                                : "Incomplete"
                              : "Incomplete"}
                          </td>
                          <td style={{ backgroundColor: "" }}>
                            <button
                              onClick={(e) =>
                                handleOpenSEFPage(e, obj_booking, {
                                  link: "ArrivalDeparture",
                                })
                              }
                            >
                              Go To{" "}
                            </button>
                          </td>
                        </tr>
                      ) : (
                        <></>
                      )}
                    </>
                  ) : (
                    <> </>
                  )}
                </>
              )}
              <tr>
                <td style={{}}></td>
                <td style={{}}></td>
                <td style={{}}></td>
                <td style={{}}></td>
                <td style={{}}></td>
                <td style={{}}></td>
                <td style={{}}></td>
              </tr>
            </>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default ConsultantBookingTable;
